import cn from 'classnames';
import { Grid } from 'ht-styleguide';
import { SkeletonImage, SkeletonBlock } from './Skeleton.parts';
import styles from './skeleton.module.scss';

type SkeletonLoadingProps = {
  containerClass?: string;
};

const SkeletonLoading = ({ containerClass }: SkeletonLoadingProps) => (
  <>
    <Grid.FullWidth classes={cn(styles.container, containerClass, 'paddingX-medium')}>
      <Grid.Row>
        <Grid.Column sm={4} md={8} lg={5} classes={styles.contentContainer}>
          <SkeletonBlock height="44" width="100" />
          <SkeletonBlock height="44" width="100" />

          <SkeletonBlock height="30" width="70" />
          <SkeletonBlock height="20" width="40" className="inlineBlock marginRight-small" />
          <SkeletonBlock height="20" width="25" className="inlineBlock marginRight-small" />
          <SkeletonBlock height="20" width="20" className="inlineBlock marginRight-small" />
          <SkeletonBlock height="20" width="30" className="inlineBlock marginRight-small" />
          <SkeletonBlock height="20" width="36" className="inlineBlock marginRight-small" />
          <SkeletonBlock height="20" width="33" className="inlineBlock marginRight-small" />
        </Grid.Column>
        <Grid.Column sm={4} md={8} lg={7} classes={styles.imageContainer}>
          <SkeletonImage />
        </Grid.Column>
      </Grid.Row>
    </Grid.FullWidth>
    <SkeletonBlock className="marginTop-large" height="72" />
    <Grid.Row classes="marginTop-large">
      <Grid.Column sm={2} md={4} lg={6} classes={styles.imageContainer}>
        <SkeletonBlock height="24" width="50" />
        <SkeletonBlock height="20" width="70" />
        <SkeletonBlock height="14" width="30" />
      </Grid.Column>
      <Grid.Column sm={2} md={4} lg={6} classes={styles.contentContainer}>
        <SkeletonBlock height="24" width="50" />
        <SkeletonBlock height="20" width="70" />
        <SkeletonBlock height="14" width="30" />
      </Grid.Column>
    </Grid.Row>
  </>
);

export default SkeletonLoading;

// The "5" should be a prop that is passed from the page - in this case, it is the serviceInfo details bullets.
